document.addEventListener("DOMContentLoaded", function() {
	var overlay = document.getElementById("cart-drawer-overlay")
	var drawer = document.getElementById("cart-drawer")
	var closeBtn = document.getElementById("cart-drawer-close")
	var cartIcon = document.querySelector("[data-cart-drawer-open]")
	var cartLink = document.querySelector("a.site-header-cart--button")

	function openDrawer() {
		var overlay = document.getElementById("cart-drawer-overlay")
		var drawer = document.getElementById("cart-drawer")
		if (overlay) {
			overlay.classList.add("active")
			overlay.setAttribute("aria-hidden", "false")
		}
		if (drawer) {
			drawer.classList.add("active")
			drawer.focus()
		}
		document.body.classList.add("cart-drawer-open")
	}

	function closeDrawer() {
		var overlay = document.getElementById("cart-drawer-overlay")
		var drawer = document.getElementById("cart-drawer")
		if (overlay) {
			overlay.classList.remove("active")
			overlay.setAttribute("aria-hidden", "true")
		}
		if (drawer) {
			drawer.classList.remove("active")
		}
		document.body.classList.remove("cart-drawer-open")
	}

	function fetchAndRenderCartDrawerSection() {
		var overlay = document.getElementById("cart-drawer-overlay")
		var drawer = document.getElementById("cart-drawer")
		if (overlay) overlay.classList.add("active")
		if (drawer) drawer.classList.add("active")
		if (overlay) overlay.setAttribute("aria-hidden", "false")
		if (drawer) drawer.focus()
		document.body.classList.add("cart-drawer-open")

		// Show loading state
		// var contents = document.getElementById("cart-drawer-contents")
		// if (contents) contents.innerHTML = '<div class="cart-drawer-loading">Loading...</div>'

		// Use Section Rendering API
		fetch(window.location.pathname + "?sections=cart-drawer")
			.then(function(res) {
				return res.json()
			})
			.then(function(data) {
				if (data["cart-drawer"]) {
					var temp = document.createElement("div")
					temp.innerHTML = data["cart-drawer"]
					var newOverlay = temp.querySelector("#cart-drawer-overlay")
					var newDrawer = temp.querySelector("#cart-drawer")
					// if (newOverlay && overlay && overlay.parentNode) {
					// 	overlay.parentNode.replaceChild(newOverlay, overlay)
					// }
					if (newDrawer && drawer && drawer.parentNode) {
						drawer.parentNode.replaceChild(newDrawer, drawer)
					}
					// Re-attach listeners after DOM replacement
					attachCartDrawerListeners()
					// Attach quantity selectors after DOM replacement
					// Re-open the drawer after replacement
					openDrawer()
				}
			})
	}

	function attachCartDrawerListeners() {
		var newCartIcon = document.querySelector("[data-cart-drawer-open]")
		var newCloseBtn = document.getElementById("cart-drawer-close")
		var newOverlay = document.getElementById("cart-drawer-overlay")
		var newDrawer = document.getElementById("cart-drawer")
		var newCartLink = document.querySelector("a.site-header-cart--button")

		if (newCartIcon) {
			newCartIcon.addEventListener("click", openDrawer)
		}
		if (newCloseBtn) {
			newCloseBtn.addEventListener("click", closeDrawer)
		}
		if (newOverlay) {
			newOverlay.addEventListener("click", closeDrawer)
		}
		document.addEventListener("keydown", function(e) {
			if (newDrawer.classList.contains("active") && e.key === "Escape") {
				closeDrawer()
			}
		})

		if (newCartLink) {
			newCartLink.addEventListener("click", function(e) {
				e.preventDefault()
				e.stopPropagation()
				if (newDrawer.classList.contains("active")) {
					closeDrawer()
				} else {
					openDrawer()
				}
			})
		}

		// Attach quantity selectors after DOM replacement
		attachCartDrawerQuantitySelectors()
	}

	function attachCartDrawerQuantitySelectors() {
		document.querySelectorAll("#cart-drawer .quantity-selector__button").forEach(function(btn) {
			btn.addEventListener("click", function(e) {
				e.preventDefault()
				e.stopPropagation()
				const currentQuantity = parseInt(btn
					.closest("quantity-selector")
					.querySelector(".quantity-selector__input").value)
				const lineId = btn
					.closest("quantity-selector")
					.querySelector(".quantity-selector__input")
					.getAttribute("data-line-id")
				const newQuantity = btn.name === "plus" ? currentQuantity + 1 : currentQuantity - 1
				triggerQtyChange(lineId, newQuantity, btn)
			})
		})
	}

	function triggerQtyChange(lineId, quantity, btn) {
		fetch("/cart/change.js", {
			method: "POST",
			body: JSON.stringify({ id: lineId, quantity: quantity }),
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			}
		})
			.then(function(res) {
				return res.json()
			})
			.then(function(data) {
				// Handle quantity update errors
				if (data.status === 422) {
					console.error("Cart update error:", data.description)
					let lineItem = btn.closest('.cart-drawer-item')
					lineItem.querySelector('.cart-item-error-message').textContent = data.description
					setTimeout(() => {
						lineItem.querySelector('.cart-item-error-message').textContent = ""
					}, 4000)
					return
				}

				// Refresh cart drawer
				window.dispatchEvent(new Event("cartcount:update"))
			})
			.catch(function(err) {
				console.error("Cart quantity update failed:", err)
			})
	}

	if (cartIcon) {
		cartIcon.addEventListener("click", openDrawer)
	}
	if (closeBtn) {
		closeBtn.addEventListener("click", closeDrawer)
	}
	if (overlay) {
		overlay.addEventListener("click", closeDrawer)
	}
	document.addEventListener("keydown", function(e) {
		if (drawer.classList.contains("active") && e.key === "Escape") {
			closeDrawer()
		}
	})

	if (cartLink) {
		cartLink.addEventListener("click", function(e) {
			e.preventDefault()
			e.stopPropagation()
			if (drawer.classList.contains("active")) {
				closeDrawer()
			} else {
				openDrawer()
			}
		})
	}

	attachCartDrawerQuantitySelectors()

	// Add to cart function and assign to every data-product-form
	function addToCart(event) {
		event.preventDefault()
		const form = event.currentTarget
		const formData = new FormData(form)

		fetch(window.Shopify.routes.root + "cart/add.js", {
			method: "POST",
			body: formData
		})
			.then(response => response.json())
			.then(data => {
				if ((data.status && data.status === 422) || (data && data.status === "bad_request")) {
					console.error("Add to cart error:", data.description || data.message)
					return
				}
				console.log("Added to cart:", data)
				window.dispatchEvent(new Event("cartcount:update"))
			})
			.catch(error => {
				console.error("Error adding to cart:", error)
			})
	}

	document.querySelectorAll("form[data-product-form]").forEach(productForm => {
		productForm.addEventListener("submit", addToCart)
	})

	// Listen for global cart update events and refresh the cart drawer
	window.addEventListener("cartcount:update", function() {
		fetchAndRenderCartDrawerSection()
	})

	// Helper to trigger section rendering for the cart-drawer section
	window.renderCartDrawerSection = function() {
		fetchAndRenderCartDrawerSection()
	}

	// Handle "Add to Cart" clicks for cart upsell products
	function handleUpsellAddToCart() {
		document.addEventListener("click", function(event) {
			if (event.target.classList.contains("cart-upsell-add-to-cart") || event.target.closest(".cart-upsell-add-to-cart")) {
				event.preventDefault()
				const button = event.target.classList.contains("cart-upsell-add-to-cart") ? event.target : event.target.closest(".cart-upsell-add-to-cart")
				const variantId = button.getAttribute("data-variant-id")
				const productTitle = button.getAttribute("data-product-title")

				if (!variantId) {
					console.error("No variant ID found")
					return
				}

				// Disable button and show loading state
				button.disabled = true
				button.textContent = "Adding..."

				fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					body: JSON.stringify({
						id: variantId,
						quantity: 1
					}),
					headers: {
						"Content-Type": "application/json",
						Accept: "application/json"
					}
				})
					.then(response => response.json())
					.then(data => {
						if (data.status === 422 || (data.errors && data.errors.length > 0)) {
							console.error("Add to cart error:", data.description || data.errors)
							button.textContent = "Error - Try Again"
							setTimeout(() => {
								button.textContent = "Add to Cart"
								button.disabled = false
							}, 2000)
						} else {
							console.log("Added to cart:", data)
							button.textContent = "Added!"
							window.dispatchEvent(new Event("cartcount:update"))
							setTimeout(() => {
								button.textContent = "Add to Cart"
								button.disabled = false
							}, 1000)
						}
					})
					.catch(error => {
						console.error("Error adding to cart:", error)
						button.textContent = "Error - Try Again"
						setTimeout(() => {
							button.textContent = "Add to Cart"
							button.disabled = false
						}, 2000)
					})
			}
		})
	}

	// Initialize upsell add to cart handler
	handleUpsellAddToCart()
})

document.addEventListener("alpine:init", () => {
	const session_fbb_key = 'fbb_product_data_cache';
	Alpine.data("FBB_cart_item", () => ({
		cart_items: [],
		fbb_items: [],
		flags: {
			show_cart_item_fbb: false,
			show_addtocart: false
		},
		init() {
			this.InitSelf();
			this.InitWatchers();
		},
		async InitSelf() {
			this.cart_items = this.$el.getAttribute('data-cart_items').split('|');
			const product_id = this.$el.getAttribute('data-id');
			this.flags.show_cart_item_fbb = this.$el.getAttribute('data-show_cart_item_fbb') === 'true';

			await this.LoadFbbData(product_id);
			if (this.fbb_items && this.fbb_items.length && this.flags.show_cart_item_fbb) {
				this.$el.closest('.fbb-items').classList.remove('visually-hidden');
			}
		},

		InitWatchers() {
			this.$watch('fbb_items', () => {
				this.flags.show_addtocart = this.fbb_items.some(item => item.selected);
			});
		},

		async LoadFbbData(product_id) {
			const marketCountry = this.$el.getAttribute('data-marketCountry');
			const marketCurrency = this.$el.getAttribute('data-marketCurrency');
			const path = this.$el.getAttribute('data-path');
			// version = date + hour:minute
			const version = new Date().toISOString().slice(0,16).replace(/[-:T]/g, '');

			let fbb_url = `https://cdn.codeblackbelt.com/json/preferences/frequently-bought-together.json?productId=${product_id}&shop=${Shopify.shop}&marketCountry=${marketCountry}&marketCurrency=${marketCurrency}&path=${encodeURIComponent(path)}&version=${version}`

			let fbb_response = await fetch(fbb_url);
			if (fbb_response.status === 404) {
				console.warn('FBB data not found for product:', product_id);
				return;
			}
			
			let fbb_data = await fbb_response.json();
			let products = fbb_data.preferences[0].products;
			products = products.map(item => {
				// console.log(item.variants)
				item.available = item.variants.filter(v => v.buyable).length > 0;
				item.selected = false;
				return item;
			});

			// remove items already in cart
			products = products.filter(item => {
				return !this.cart_items.includes(item.id.toString());
			});

			// add the items to cart you may also like section
			let $cart_upsells = document.querySelector('.cart-drawer-upsell-slider');
			if ($cart_upsells) {				
				[...products].slice(0,2).forEach(item => {
					(async () => {
						let res = await fetch(`/products/${item.url}?section_id=joes-api-product-item-upsell`).then(res => res.text());
						let $upsells = new DOMParser().parseFromString(res, 'text/html').querySelectorAll('.shopify-section .cart-upsell-item');
						$upsells.forEach($upsell => {
							$cart_upsells.append($upsell);
						});
					})();
				});
			}
			this.fbb_items = [...products];
		},

		async e_AddSelectedToCart() {
			const selected_items = this.fbb_items.filter(item => item.selected);
			let variants = selected_items.map(item => {
				return {
					id: item.variant_id,
					quantity: 1
				};
			});

			if (variants.length === 0) return;

			await fetch("/cart/add.js", {
				method: "POST",
				body: JSON.stringify({ items: variants }),
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json"
				}
			})
				.then(response => response.json())
				.then(data => {
					if ((data.status && data.status === 422) || (data && data.status === "bad_request")) {	
						console.error("Add to cart error:", data.description || data.message);
					}
					console.log("Added to cart:", data);
					window.dispatchEvent(new Event("cartcount:update"));
				})
				.catch(error => {
					console.error("Error adding to cart:", error);
				});
		}
	}));

	Alpine.data('CartUpsells', () => ({
		init() {
			// load best sellers`
			this.InitSelf();
		},
		async InitSelf() {
			let $cart_upsells = document.querySelector('.cart-drawer-upsell-slider');
			if ($cart_upsells) {				
				let res = await fetch('/collections/all?section_id=joes-api-best-seller-items&sort_by=best-selling').then(res => res.text());
				let $upsells = new DOMParser().parseFromString(res, 'text/html').querySelectorAll('.shopify-section .cart-upsell-item');
				$upsells = Array.from($upsells).slice(0,4); // limit to 4 items
				$upsells.forEach($upsell => {
					$cart_upsells.append($upsell);
				});
			}
		}
	}));
});